import { render, staticRenderFns } from "./ExtractPanel.vue?vue&type=template&id=2bf169b1&scoped=true"
import script from "./ExtractPanel.vue?vue&type=script&lang=js"
export * from "./ExtractPanel.vue?vue&type=script&lang=js"
import style0 from "./ExtractPanel.vue?vue&type=style&index=0&id=2bf169b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf169b1",
  null
  
)

export default component.exports